import React from 'react'
import propTypes from 'prop-types'
import Icon, {iconNames} from "components/icon"
import {prefix} from 'helpers/component'
import './groupOverlay.scss'

const getClass = prefix('groupOverlay-')
const getClassName = prefix('pivotTable-group-')

const GroupOverlay = (props) => {
  const {
    preLabel,
    label,
    postLabel,
    showSelector,
    onToggle,
    expanded,
  } = props

  return (
    <div className={getClass('container')} onMouseDown={e => e.stopPropagation()}>
      {showSelector && (
        <span className={getClassName('selector')} onClick={onToggle}>
          <Icon
            key={expanded ? 'collapse' : 'expand'}
            name={expanded ? iconNames.collapse : iconNames.expand}
            size={12}
          />
        </span>
      )}
      <div className={getClass('text')}>
        {preLabel}
        {label}
        {postLabel}
      </div>
    </div>
  )
}

GroupOverlay.propTypes = {
  preLabel: propTypes.node,
  label: propTypes.node,
  postLabel: propTypes.node,
  showSelector: propTypes.bool,
  onToggle: propTypes.func,
  expanded: propTypes.bool,
}

export default GroupOverlay
